module.exports = require("ngx-bootstrap/tooltip");